var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { isUndef } from '@lhb/func';
import { parseArrayToString } from '@lhb/func';
import { Toast } from 'vant';
import { routePage } from '@lhb/bridge';
import * as dd from 'dingtalk-jsapi';
import { getCookie, setCookie } from './tools';
import { jwtDecode } from 'jwt-decode';
import { getAfferentToken } from './bridge';
import { _get } from '../request';
export var isOss = process.env.STATIC_TYPE === 'oss';
/**
 * [深拷贝对象或者数组]
 * @param  {any} obj
 */
export function deepCopy(value) {
    if (Array.isArray(value)) {
        return value.map(deepCopy);
    }
    else if (value && typeof value === 'object') {
        var res = {};
        for (var key in value) {
            res[key] = deepCopy(value[key]);
        }
        return res;
    }
    else {
        return value;
    }
}
/**
 * 时间格式化
 * time: 2019-08-10 10:52:24
 * sign: '/' 替换连接符
 * len： 显示长度
 */
export var timeFormatte = function (time, sign, len) {
    if (sign === void 0) { sign = '.'; }
    if (time === '' || time === undefined || time === null) {
        return '';
    }
    time = time.replace(/-/g, sign);
    // return len ? time.substr(0, len) : time;
    return len ? time.substring(0, len) : time;
};
/**
 * 时间格式化
 * time: 2019.08.10 10:52:24
 * sign: '-' 替换连接符
 * len： 显示长度
 */
export var timeFormatterLine = function (time, sign, len) {
    if (sign === void 0) { sign = '-'; }
    if (time === '' || time === undefined || time === null) {
        return '';
    }
    time = time.replace(/\./g, sign);
    return len ? time.substring(0, len) : time;
};
/**
 * @description 时间格式化
 * @param time 格式化前 2019-08-10 10:52:24
 * @return 格式化后 2019.08.10
 */
export var timeFormatterYMD = function (time) {
    return timeFormatte(time, '.', 10);
};
/**
 * 获取指定日期的往前/往后n天日期，
 * yyyy.MM.dd，年月日之间的连接符按照入参数
 *
 * time: 2019-08-10
 * days: 天数间隔，往后使用正整数（+30，time的30天后），往前使用负整数（-30，time的30天前）
 * sign: 年、月、日之间的连接符，默认'.'
 */
export var getPrevNextDate = function (time, days, sign) {
    if (days === void 0) { days = 0; }
    if (sign === void 0) { sign = '.'; }
    if (!time)
        return '';
    var date = new Date(time);
    date.setDate(date.getDate() + days);
    var y = date.getFullYear();
    var m = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
    var d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    var result = "" + y + sign + m + sign + d;
    return result;
};
/*
  *判断数据类型
*/
export var getObjectType = function (obj) {
    var type = '';
    switch (Object.prototype.toString.call(obj)) {
        case '[object Function]':
            type = 'Function';
            break;
        case '[object Array]':
            type = 'Array';
            break;
        case '[object String]':
            type = 'String';
            break;
        case '[object Number]':
            type = 'Number';
            break;
        case '[object Boolean]':
            type = 'Boolean';
            break;
        default:
            type = 'Object';
    }
    return type;
};
/**
 * @param {Object} obj  要删除属性的目标对象
 * @param {Boolean} isRecursion  是否处于递归状态
 * 删除对象的属性值为null或undefined或者''的属性，无论嵌套多深，当前函数只适用请求接口时的传参的过滤
 */
export function delObjEmptyProVal(obj, isRecursion) {
    if (isRecursion === void 0) { isRecursion = false; }
    var result;
    if (isRecursion) {
        result = obj;
    }
    else {
        result = deepCopy(obj); // 避免vue中绑定的data
    }
    for (var item in result) {
        var val = result[item]; // 值
        if (val === null || val === undefined || val === '') {
            Reflect.deleteProperty(result, item);
        }
        else if (getObjectType(val) === 'Object') {
            delObjEmptyProVal(val, true);
        }
    }
    return result;
}
/**
 * 获取根元素的font-size
 * @returns {Number} 根文件的font-size大小
 */
export function getRootFontSize() {
    var doc = document.documentElement;
    var fontSize = doc.style.fontSize || window.getComputedStyle(doc).fontSize;
    return parseFloat(fontSize);
}
/**
 * 将px转为rem
 * @returns {String} rem值
 */
export function pxToRem(pxVal) {
    return pxVal / getRootFontSize() + "rem";
}
/**
 *
 * @param el dom节点
 * @returns boolean
 */
export function isDOM(el) {
    // 首先判断是否支持HTMLELement，如果支持，使用HTMLElement，如果不支持，通过判断DOM的特征，如果拥有这些特征说明就是ODM节点，特征使用的越多越准确
    return (typeof HTMLElement === 'function')
        ? (el instanceof HTMLElement)
        : (el && (typeof el === 'object') && (el.nodeType === 1) && (typeof el.nodeName === 'string'));
}
/**
 * 计算指定元素占满剩余空间所需的高度
 * @returns string | number
 */
export function calculateFreeSpaceHeight(targetEl, isRem) {
    if (isRem === void 0) { isRem = false; }
    if (!isDOM(targetEl))
        return;
    // 移动端应该使用window.screen.height（包含了状态栏等的高度）
    var screenHeight = window.screen.height; // document.documentElement.clientHeight || document.body.clientHeight;
    var top = targetEl.getBoundingClientRect().top;
    var height = screenHeight - top;
    if (isRem) {
        return "" + pxToRem(height);
    }
    return height;
}
/**
 * 删除数组中的某一项
 * @param arr 数组
 * @param key 对应值
 */
export function arrayDelete(arr, key) {
    var newArr = Array.from(new Set(deepCopy(arr)));
    var index = arr.indexOf(key);
    if (index < 0) {
        return;
    }
    newArr.splice(index, 1);
    return newArr;
}
export function objectArrayDelete(arr, key, value) {
    if (isUndef(value)) {
        console.error('传入类型为对象时, value 不能为空');
        return arr;
    }
    var newArr = deepCopy(arr);
    for (var i = 0; i < newArr.length; i++) {
        if (newArr[i][key] === value) {
            newArr.splice(i, 1);
        }
    }
    return newArr;
}
/**
 * 是否处于 app 环境
 * @returns Boolean
 */
export var isApp = function () {
    var UA = navigator.userAgent.toLowerCase(); // location-android ,location-ios
    return UA === 'location-android' || UA === 'location-ios';
};
/**
 * 给数值添加单位
 * @param val 数值
 * @param unit 单位
 * @returns 数值 + 单位
 */
export function addUnit(val, unit) {
    return isUndef(val) || val === '' ? val : val + unit;
}
export function emptyImage(url) {
    return url || 'https://cert.linhuiba.com//Fpx1-mYIcunvL34hf_y2IWxrpPn4';
}
// 根据对象中某个属性值进行排序（属性值必须是number）,默认降序
export function targetValSort(arr, property, desc) {
    if (desc === void 0) { desc = true; }
    return arr.sort(function (a, b) {
        var val1 = a[property];
        var val2 = b[property];
        return desc ? val2 - val1 : val1 - val2;
    });
}
// 返回经过处理的词云数据
export function formattingWordcloudData(original, sortFieldName, label, desc) {
    if (sortFieldName === void 0) { sortFieldName = 'heat'; }
    if (label === void 0) { label = 'name'; }
    if (desc === void 0) { desc = false; }
    var sortData = targetValSort(original, sortFieldName, desc); // 根据heat排序后的品牌，倒序（从大到小）
    // const count = sortData.length;
    return sortData.map(function (brand) {
        var heat = brand[sortFieldName];
        var name = brand[label];
        var len = name.length; // 品牌名长度
        // const coefficient = (heat * 0.3) * ((count + 8) / count); // 系数，热度值系数（正比） * 数据量系数（反比）
        // const coefficient = 1;
        var size = heat * len;
        // 设置展示的最大值
        if (size > 21) {
            size = 21;
        }
        // 最小值
        if (size < 6) {
            size = 6;
        }
        return [name, size];
    });
}
// echarts中坐标轴单位：以最小值为单位
export function echartsFormatUnit(data) {
    var minVal = Math.min.apply(Math, data); // 最小值
    var unit = 10000;
    if ((minVal / unit) >= 1) { // 以万为单位
        return {
            name: 'w',
            value: 10000
        };
    }
    else {
        return {
            name: '',
            value: 1
        };
    }
}
// 图表类数据转换(普通图表)
/**
 *
 * @param data 数组
 * @param optionKey 横坐标key
 * @param optionVal Y坐标的key
 * @param optionValTwo 第二条Y轴的key 默认不传,如果传入会多返回一个y2的数组
 * @returns {x,y}
 */
export function dataConvertToEchartsData(data, optionKey, optionVal, optionValTwo) {
    if (optionKey === void 0) { optionKey = 'name'; }
    if (optionVal === void 0) { optionVal = 'value'; }
    if (!(Array.isArray(data) && data.length))
        return {};
    var x = []; // x轴数据
    var y = []; // y轴数据
    var y2 = []; // y轴数据
    data.forEach(function (item) {
        x.push(item[optionKey]);
        y.push(item[optionVal]);
        optionValTwo && y2.push(item[optionValTwo]);
    });
    return __assign({ x: x,
        y: y }, (optionValTwo && { y2: y2 }));
}
export var swipeDirection = function (x1, x2, y1, y2) {
    return Math.abs(x1 - x2) >= Math.abs(y1 - y2) ? (x1 - x2 > 0 ? 'Left' : 'Right') : (y1 - y2 > 0 ? 'Up' : 'Down');
};
// 移动端手势
export var gestureTouch = function (el, fn) {
    var startPoint = {};
    el.addEventListener('touchstart', function (e) {
        // e.preventDefault();
        startPoint = {
            x: e.changedTouches[0].pageX,
            y: e.changedTouches[0].pageY
        };
    });
    el.addEventListener('touchend', function (e) {
        var nowPoint = {
            x: e.changedTouches[0].pageX,
            y: e.changedTouches[0].pageY
        };
        // if (Math.abs(nowPoint.x - startPoint.x) > 10 && Math.abs(nowPoint.y - startPoint.y) > 10) {
        if (Math.abs(nowPoint.x - startPoint.x) > 10) {
            e.direction = swipeDirection(startPoint.x, nowPoint.x, startPoint.y, nowPoint.y);
            fn && fn.call(el, e);
        }
    });
};
// 解决ios下上一页（有滚动条的列表页）跳转到其他页面返回上一页时出现的部分白屏
// https://github.com/vuejs/vue-router/issues/1990
// https://github.com/vuejs/vue/issues/5533
export function scrollInAsyncLoadList(vm) {
    vm.$nextTick(function () {
        window.scrollTo(0, 1);
        window.scrollTo(0, 0);
    });
}
/** 用来转包服务端接口获取到的 permissions 数组格式
 * @param {Array} permissions 操作列表
 * @param {Array<string>} filterKeys 过滤项合集
 * @example
  [
    {event: "tenant:create", name: "新建"},
    {event: "tenant:batchDisable", name: "批量停用"}
  ]
  =>
  [
    {
      isBatch: false, event: "create", name: "新建", text:"新建",
      func: handleCreate
    },
    {
      isBatch: true, event: "batchDisable", name: "批量停用", text:"批量停用",
      func: handleBatchDisable
    }
  ]
*/
export function refactorPermissions(permissions, filterKeys) {
    var result = [];
    if (!(Array.isArray(permissions) && permissions.length))
        return result;
    permissions.forEach(function (item) {
        var lastIndexOf = item.event.lastIndexOf(':');
        var eventName = item.event.slice(lastIndexOf + 1);
        if (filterKeys && filterKeys.length && filterKeys.includes(eventName)) {
            return;
        }
        result.push(__assign(__assign({}, item), { event: eventName }));
    });
    return result;
}
/**
 *
 * @param num 传入的数值
 * @param dicimal 含小数时截取n位小数
 * @param uncompromising true时会在Number.isInteger为true时自动拼接dicimal
 * @returns 整数时仍旧返回整数；小数时截取n位小数
 */
// 整数时显示整数；小数时截取n位小数（默认2位）
export function fixNumber(num, dicimal, uncompromising) {
    if (dicimal === void 0) { dicimal = 2; }
    if (uncompromising === void 0) { uncompromising = false; }
    // return num - parseInt(num + '') > 0 ? num.toFixed(dicimal) : num;
    if (+num) {
        // return Number.isInteger(+num) ? +num : (+num as number).toFixed(dicimal);
        return Number.isInteger(+num) && !uncompromising ? +num : (+num).toFixed(dicimal);
    }
    return num;
}
/**
 * [showInvalidFieldMsg 解析form校验未通过的字段信息]
 * @param  {[type]} object    未通过校验的字段
 * @param  {[type]} maxLength 提示内容的最大个数，默认 -1无限制
 * @return {[type]}        [description]
 */
export function showInvalidFieldMsg(errorFields, maxLength) {
    if (maxLength === void 0) { maxLength = -1; }
    if (!Array.isArray(errorFields) || !errorFields.length) {
        return null;
    }
    console.log('errorFields', errorFields);
    var arr = errorFields.map(function (item) { return item.message; });
    var messages = maxLength === -1 ? arr : arr.slice(0, maxLength);
    Toast(parseArrayToString(messages));
    return messages;
}
/** 距离工具转换 米/公里 */
export function radiusFormat(value) {
    return value >= 1000 ? value / 1000 + "\u516C\u91CC" : value + "\u7C73";
}
/** 高德地图清理内存 */
export function amapClearMemory(mapIns, amapDom) {
    var _a, _b, _c;
    (_c = (_b = (_a = amapDom.querySelector('canvas.amap-layer')) === null || _a === void 0 ? void 0 : _a.getContext('webgl')) === null || _b === void 0 ? void 0 : _b.getExtension('WEBGL_lose_context')) === null || _c === void 0 ? void 0 : _c.loseContext();
    if (!mapIns)
        return;
    mapIns.remove(mapIns.getLayers(), mapIns.getAllOverlays());
    mapIns.destroy();
    mapIns = null;
}
/**
 * 是否企业微信内置浏览器
 */
export function isQWWorkBrowser() {
    var ua = navigator.userAgent;
    return ua.includes('wxwork');
}
/** 是否是微信浏览器打开 */
export var isWx = function () { return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1; };
export var getCityForAMapData = function (data) {
    var _cityForAMap = [];
    // 禁选特殊的行政区
    data === null || data === void 0 ? void 0 : data.forEach(function (item) {
        var _a, _b;
        if (['台湾', '香港', '澳门'].some(function (region) { return item.name.indexOf(region) !== -1; })) {
            (_a = item.children) === null || _a === void 0 ? void 0 : _a.forEach(function (city) {
                var _a;
                city.disabled = true;
                (_a = city.children) === null || _a === void 0 ? void 0 : _a.forEach(function (district) {
                    district.disabled = true;
                });
                // cityForAMap数据组装
                _cityForAMap.push({
                    name: city.name,
                    id: city.id,
                    code: city.code,
                    provinceName: item.name,
                    provinceId: item.id,
                    provinceCode: item.code,
                    district: city.children,
                    disabled: true
                });
            });
            return __assign(__assign({}, item), { disabled: true });
        }
        // cityForAMap数据组装
        (_b = item.children) === null || _b === void 0 ? void 0 : _b.forEach(function (city) {
            _cityForAMap.push({
                name: city.name,
                id: city.id,
                code: city.code,
                provinceName: item.name,
                provinceId: item.id,
                provinceCode: item.code,
                district: city.children
            });
        });
        return item;
    });
    return _cityForAMap;
};
// 是否是钉钉移动端
export var isDDAppEnv = function () {
    var _a;
    var platform = (_a = dd === null || dd === void 0 ? void 0 : dd.env) === null || _a === void 0 ? void 0 : _a.platform;
    return platform === 'android' || platform === 'ios';
};
// 往area-insight跳转的公共方法
// path 是路由
// 注意使用jumpToReactH5时需要注意跳转前的页面是否需要更新的逻辑，如需更新，请使用refreshH5进行监听返回后的更新逻辑，例如：从store-h5跳转到area-insight后，返回到store-h5时，需要更新store-h5页面数据
export var jumpToReactH5 = function (path) {
    if (!path) {
        throw new Error('请传入跳转的路由');
    }
    if (isApp()) { // 采用桥接可以缓存当前页
        routePage({ type: 'reactH5', path: path });
        return;
    }
    // const platform = dd.env.platform; // 钉钉运行环境判断
    var targetUrl = process.env.AREA_INSIGHT;
    var targetDDquery = '';
    if (isDDAppEnv()) { // 钉钉移动端
        if (path.includes('?')) {
            targetDDquery = '&dd_full_screen=true';
        }
        else {
            targetDDquery = '?dd_full_screen=true';
        }
    }
    window.location.href = "" + targetUrl + path + targetDDquery;
};
/**
 * @description 判断是否需要继续解码（url参数中经过encodeURIComponent的参数会在分享过程中被二次编码），如果需要就继续解码，直到解码成功
 * @param {string} value 需要解码的值
 * @returns {string} 解码后的值
 */
export function recursiveDecodeURIComponent(encodedStr) {
    try {
        // 尝试进行一次解码
        var decodedStr = decodeURIComponent(encodedStr);
        // 如果解码后的字符串和原字符串相同，说明已经无法再解码
        if (decodedStr === encodedStr) {
            return decodedStr;
        }
        // 否则，继续递归解码
        return recursiveDecodeURIComponent(decodedStr);
    }
    catch (error) {
        // 如果解码过程中出现错误，说明已经是最终解码结果
        return encodedStr;
    }
}
/**
 * 是否是飞书环境内
 */
export var isLarkEnv = function () {
    return window.h5sdk && window.tt;
};
// 判断是否是ios设备
export function isIOS() {
    var userAgent = navigator.userAgent;
    var iosRegex = /(iPhone|iPad|iPod).*OS (\d+)_(\d+)/i;
    return iosRegex.test(userAgent);
}
/**
 * @description 是否移动端（参考console-pc项目实现）
 */
export function isMobileDevice() {
    var ua = navigator.userAgent.toLowerCase();
    var isMobileUA = /iphone|ipad|ipod|android|windows phone|mobile|tablet/i.test(ua);
    var hasOrientation = typeof window.orientation !== 'undefined';
    // const screenWidth = window.innerWidth || document.documentElement.clientWidth;
    return isMobileUA || hasOrientation /* || screenWidth < 1024*/;
}
/**
 * ios 手机的默认状态栏高度
 */
export function defaultStatusBarHeightIOS() {
    if (isApp()) { // App环境内
        return 48;
    }
    if (isLarkEnv() && isIOS()) { // 飞书的ios环境内
        return 44;
    }
    if (isDDAppEnv() && isIOS()) { // 钉钉环境内
        return 44;
    }
    return 0;
}
/**
 * @param substring token值
 * @returns {} 存放在token中的数据，比如：
 * substring为: "id=2 employeeId=358574 tenantId=117663 clientKey=1000114 share=false createAt=2025-07-22 14:03:58"，
 * 解析后会变成对应的键值对对象：
 * {
 *  employeeId: 358574,
 *  ...
 * }
 */
export function parseTokenSubString(substring) {
    // 利用正则表达式找出所有的键值对
    var regex = /(\w+)=([^=\s]+|".*?"|'.*?'|true|false)/g;
    var result = {};
    var match;
    while ((match = regex.exec(substring)) !== null) {
        var key = match[1];
        var value = match[2];
        // 处理布尔值
        if (value === 'true' || value === 'false') {
            value = value === 'true';
        }
        else if (!isNaN(value) && value.trim() !== '') { // 处理数值
            value = Number(value);
        }
        else if ((value.startsWith('"') && value.endsWith('"')) ||
            (value.startsWith("'") && value.endsWith("'"))) { // 处理带引号的字符串
            value = value.slice(1, -1);
        }
        result[key] = value;
    }
    return result;
}
/**
 * 利用token解析出员工id和租户id，然后写入到cookie，确保埋点上报时有对应的参数
 */
export function makeUseOfTokenGetData() {
    var targetEmployeeId = getCookie('EMPLOYEE_ID');
    var targetTenantId = getCookie('TENANT_ID');
    var token = getCookie('flow_token');
    // 处理H5环境下，会话cookie存储的员工id和租户id因为关闭会话导致的丢失问题
    if (!isApp() && token && (!targetEmployeeId || !targetTenantId)) {
        var decodedVal = jwtDecode(token);
        var sub = (decodedVal || {}).sub;
        var targetSubObj = sub ? parseTokenSubString(sub) : {};
        var _a = targetSubObj || {}, employeeId = _a.employeeId, tenantId = _a.tenantId;
        if (employeeId) {
            setCookie('EMPLOYEE_ID', employeeId);
        }
        if (tenantId) {
            setCookie('TENANT_ID', tenantId);
        }
    }
}
/**
 * 利用token解析出token中存储的数据，目前用在App环境内切换租户/环境后，本地cookie中的TENANT_ID和EMPLOYEE_ID未更新的场景。
 */
export function parseTokenGetData() {
    return __awaiter(this, void 0, void 0, function () {
        var headersToken, uimsToken, decodedVal, sub, targetSubObj;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    headersToken = getCookie('UIMS_TOKEN');
                    if (!isApp()) return [3 /*break*/, 3];
                    if (!headersToken) return [3 /*break*/, 1];
                    headersToken = headersToken.substring(2, headersToken.length - 8);
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, getAfferentToken()];
                case 2:
                    uimsToken = (_a.sent()).uimsToken;
                    headersToken = uimsToken;
                    _a.label = 3;
                case 3:
                    // 不考虑H5开发环境，如果需要就取消该段注释
                    // else {
                    //   if (process.env.NODE_ENV === 'development') {
                    //     headersToken = getCookie('localUimsToken');
                    //   } else {
                    //     headersToken = getCookie('flow_token');
                    //   }
                    // }
                    if (!headersToken)
                        return [2 /*return*/, null];
                    decodedVal = jwtDecode(headersToken);
                    sub = (decodedVal || {}).sub;
                    targetSubObj = sub ? parseTokenSubString(sub) : {};
                    return [2 /*return*/, targetSubObj || {}];
            }
        });
    });
}
/**
 * @description 从完整地址中去掉省市区信息
 * @param address 完整地址
 * @param pcdNames 字符串数组，包含省市区名称，个数不限制，包含的单个字符串为空时无实际效果
 * @return 去掉省市区后的地址
 */
export function removePcdFromAddress(address, pcdNames) {
    var res = address || '';
    pcdNames.forEach(function (name) {
        if (name && res.startsWith(name)) {
            res = res.slice(name.length);
        }
    });
    return res;
}
/**
 * @description 省市区和详细地址拼接
 * @param address 去掉省市区后的详细地址
 * @param pcdNames 字符串数组，包含省市区名称，个数不限制，包含的单个字符串为空时无实际效果
 * @return 省市区和详细地址拼接后的完整地址
 */
export function joinPcdToAddress(detailAddress, pcdNames) {
    var res = '';
    __spreadArrays(pcdNames, [detailAddress]).forEach(function (name) {
        if (name && !res.startsWith(name)) {
            res += name;
        }
    });
    return res;
}
// 从七牛云获取一个授权token或者从oss获取一个占位token（无意义）
export function getUploadCustomToken(params, isShare) {
    if (isShare === void 0) { isShare = false; }
    if (isOss) {
        return new Promise(function (resolve) {
            // oss模式不需要token，占位就行
            resolve({
                data: {
                    token: 'tokenPlaceHolder'
                }
            });
        });
    }
    else {
        /**
         * 七牛token
         * https://yapi.lanhanba.com/project/297/interface/api/34045
         */
        /**
         * 分享页用的七牛token
         * https://yapi.lanhanba.com/project/297/interface/api/
         * 上面的/qiniu/token服务端把改成了需要登录才能使用，所以分享场景时使用该新接口
         */
        return _get(isShare ? "/v2/qiniu/share/token" : "/v2/qiniu/token", __assign({}, params), {
            isMock: false,
            needHint: true,
            isTerra: true,
        });
    }
}
/**
 *  是否企业微信内置浏览器
 */
export var isWxWorkBrowser = function () {
    var ua = navigator.userAgent;
    return /MicroMessenger/i.test(ua) && /WxWork/i.test(ua); // 微信且企业微信
};
export var wxWorkEnable = function () { return isWxWorkBrowser(); };
/**
 * @description 重试执行函数，直到成功或尝试次数超过3次
 * @param fn 要执行的函数，返回值为boolean类型，true表示成功
 * @return {*}
 * @demo
 * retry(() => {
 *   console.log('尝试执行');
 *   return true;
 * });
 */
export var retryExecute = function (fn) {
    var attempts = 0;
    var retryInterval = setInterval(function () {
        attempts++;
        if (fn() || attempts >= 3) {
            clearInterval(retryInterval);
        }
    }, 100);
};
